import type { RouteRecordRaw } from 'vue-router';

import AuthLayout from '@/layouts/AuthLayout.vue';

export const authRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login-page',
    meta: { layout: AuthLayout },
    component: () => import('@/pages/Auth/LoginPage.vue'),
  },
  {
    path: '/oauth2-redirect',
    name: 'oauth2-redirect',
    meta: { layout: AuthLayout },
    component: () => import('@/pages/Auth/OAuth2RedirectPage.vue'),
  },
];
